import Vue from 'vue';
import Slick from 'vue-slick';

export default {
    init() {
        Vue.component('Slick', Slick);
    },
};
